import { useMemo } from 'react';

import { getABNVariant } from '~/src/helpers/abn-tests';

export const TARIFF_CARDS_REDESIGN = {
    testName: 'tariff_cards_redesign',
    variants: {
        NEW: 'new_tariff_card',
        OLD: 'old_tariff_card',
    },
};

export const isRedesignedTariffCards = () => getABNVariant(TARIFF_CARDS_REDESIGN.testName) === TARIFF_CARDS_REDESIGN.variants.NEW;

export const useAbnTariffCardByRedesign = () => useMemo(isRedesignedTariffCards, []);
